import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getPortalInfo } from "../hooks/useSignup";
import RegBasicData from "./basicDataPage/basicDataPage";
import RegContentQuality from "./contentQualityPage/contentQualityPage";
import RegPopularity from "./popularity/popularity";
import RegStatisticsCodes from "./statisticsCodesPage/statisticsCodesPage";
import RegThemePage from "./themePage/themePage";

const Cbreadcrumb = (props) => {
  const { portal_id } = useParams();
  const [AutoFillData, setAutoFillData] = useState([]);
  useEffect(() => {
    if (portal_id) {
      getData();
    }
  }, []);

  // To auto fill the input fields if the domain is already registered by using getPortalInfo

  async function getData() {
    const result = await getPortalInfo({ id: portal_id });
    setAutoFillData(result.data);
  }

  return (
    <>
      <div className="mt-4">
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="pills-basic-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-basic"
              type="button"
              role="tab"
              aria-controls="pills-basic"
              aria-selected="true"
            >
              Basic Data
            </button>
          </li>
          <li className="nav-item text-dark mt-2">
            {" "}
            <FontAwesomeIcon icon={faAngleDoubleRight} />{" "}
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-theme-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-theme"
              type="button"
              role="tab"
              aria-controls="pills-theme"
              aria-selected="false"
            >
              Theme
            </button>
          </li>
          <li className="nav-item text-dark mt-2">
            {" "}
            <FontAwesomeIcon icon={faAngleDoubleRight} />{" "}
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-popularity-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-popularity"
              type="button"
              role="tab"
              aria-controls="pills-popularity"
              aria-selected="false"
            >
              Popularity
            </button>
          </li>
          <li className="nav-item text-dark mt-2">
            {" "}
            <FontAwesomeIcon icon={faAngleDoubleRight} />{" "}
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-statistics-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-statistics"
              type="button"
              role="tab"
              aria-controls="pills-statistics"
              aria-selected="false"
            >
              Statistics & Codes
            </button>
          </li>
          <li className="nav-item text-dark mt-2">
            {" "}
            <FontAwesomeIcon icon={faAngleDoubleRight} />{" "}
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-quality-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-quality"
              type="button"
              role="tab"
              aria-controls="pills-quality"
              aria-selected="false"
            >
              Content Quality
            </button>
          </li>
        </ul>
      </div>

      <div className="tab-content mt-5" id="pills-tabContent">
        <div
          className="tab-pane fade show active"
          id="pills-basic"
          role="tabpanel"
          aria-labelledby="pills-basic-tab"
        >
          <RegBasicData regPage={props.page} AutoFillDataProp={AutoFillData} />
        </div>
        <div
          className="tab-pane fade"
          id="pills-theme"
          role="tabpanel"
          aria-labelledby="pills-theme-tab"
        >
          <RegThemePage regPage={props.page} AutoFillDataProp={AutoFillData} />
        </div>
        <div
          className="tab-pane fade"
          id="pills-popularity"
          role="tabpanel"
          aria-labelledby="pills-popularity-tab"
        >
          <RegPopularity regPage={props.page} AutoFillDataProp={AutoFillData} />
        </div>
        <div
          className="tab-pane fade"
          id="pills-statistics"
          role="tabpanel"
          aria-labelledby="pills-statistics-tab"
        >
          <RegStatisticsCodes
            regPage={props.page}
            AutoFillDataProp={AutoFillData}
          />
        </div>
        <div
          className="tab-pane fade"
          id="pills-quality"
          role="tabpanel"
          aria-labelledby="pills-quality-tab"
        >
          <RegContentQuality
            regPage={props.page}
            addnewpage={props.page}
            AutoFillDataProp={AutoFillData}
          />
        </div>
      </div>
    </>
  );
};

export default Cbreadcrumb;
